import reducer from "redux/lesson/paragraph/reducer";

export default reducer;
